import { createI18n } from 'vue-i18n';

import en from './i18n/en.json';
import zh from './i18n/zh.json';
import zhHK from './i18n/zh-HK.json';
import de from './i18n/de.json';
import es from './i18n/es.json';
import ja from './i18n/ja.json';
import th from './i18n/th.json';
import tr from './i18n/tr.json';
import ko from './i18n/ko.json';
import frOverrides from './i18n/fr.json';
import ptOverrides from './i18n/pt.json';
import ruOverrides from './i18n/ru.json';
import itOverrides from './i18n/it.json';
import { getInitialLanguage } from './utils/language';

const fr = { ...en, ...frOverrides };
const pt = { ...en, ...ptOverrides };
const ru = { ...en, ...ruOverrides };
const it = { ...en, ...itOverrides };

const i18n = createI18n({
    locale: getInitialLanguage(),
    fallbackLocale: 'en',
    legacy: false,
    globalInjection: true,
    messages: {
        en,
        zh,
        'zh-HK': zhHK,
        de,
        es,
        ja,
        th,
        tr,
        ko,
        fr,
        pt,
        ru,
        it
    },
});

export default i18n;
